/**
 * 获取
 */
// 用户id
export const clientId = () => localStorage.getItem('clientId')
// token
export const token = () => localStorage.getItem('token')
